import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";

export enum DEALER_LOCKOUT_UPSERT_IMAGE_ACTION {
    UPLOAD,
    CREATE,
}

@Component({
    selector: "app-edit-lockout-screen",
    templateUrl: "./edit-lockout-screen.component.html",
    styleUrls: ["./edit-lockout-screen.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditLockoutScreenComponent implements OnInit, OnDestroy {
    @Output() upsertActionChange: EventEmitter<DEALER_LOCKOUT_UPSERT_IMAGE_ACTION> = new EventEmitter<DEALER_LOCKOUT_UPSERT_IMAGE_ACTION>();
    public createOrUploadForm = new FormGroup({
        upsertAction: new FormControl(DEALER_LOCKOUT_UPSERT_IMAGE_ACTION.UPLOAD, Validators.required),
    });
    public dealerLockoutUpsertImageAction = DEALER_LOCKOUT_UPSERT_IMAGE_ACTION;
    private readonly unsubscribe$ = new Subject();

    ngOnInit(): void {
        this.createOrUploadForm
            .get("upsertAction")
            .valueChanges.pipe(takeUntil(this.unsubscribe$))
            .subscribe((value: DEALER_LOCKOUT_UPSERT_IMAGE_ACTION) => {
                this.upsertActionChange.emit(value);
            });

        this.upsertActionChange.emit(this.createOrUploadForm.get("upsertAction")?.value as DEALER_LOCKOUT_UPSERT_IMAGE_ACTION);
    }

    public isValid(): boolean {
        return this.createOrUploadForm.valid;
    }

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}
